/**
 * Operazioni abilitabili di un datasource nel Builder.
 *
 * L'elenco proposto dalle checkbox deriva dalle `operations` dell'adapter
 * selezionato (route `/datasource-adapters`); fallback sulla costante
 * condivisa `DATASOURCE_OPERATIONS` se l'elenco adapter non è disponibile.
 */

import { DATASOURCE_OPERATIONS } from "@onecreator/shared";
import type { EnabledDataSourceOperation } from "@onecreator/shared";

interface AdapterOperationsInfo {
  id: string;
  operations: string[];
}

const isEnabledOperation = (op: string): op is EnabledDataSourceOperation =>
  (DATASOURCE_OPERATIONS as readonly string[]).includes(op);

export function getAvailableOperations(
  adapters: AdapterOperationsInfo[],
  adapterId: string,
): EnabledDataSourceOperation[] {
  const adapter = adapters.find((a) => a.id === adapterId);
  if (!adapter) return [...DATASOURCE_OPERATIONS];
  return adapter.operations.filter(isEnabledOperation);
}

export function pruneUnsupportedOperations<T extends string>(
  enabled: T[],
  available: readonly string[],
): T[] {
  return enabled.filter((op) => available.includes(op));
}
